import { notification } from 'antd';

// file Reader for converting file to base64
export const fileReaderPromise = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const resolveAndSendObject = async (array) => {
  const promiseArray = array.map(async (file) => {
    return await fileReaderPromise(file);
  });

  const filesArrayInBase64 = await Promise.all(promiseArray);
  const files_base64 = filesArrayInBase64.map((file, index) => ({
    file_str_base64: file.replace('data:', '').replace(/^.+,/, ''),
    filename: array[index].name,
  }));
  return files_base64;
};

export const checkingForErrorNotification = (error, message) => {
  if (error) {
    return notification.error({
      message: message,
    });
  } else {
    notification.success({
      message: message,
    });
  }
};
export const checkingForOnlyErrorNotification = (error, message) => {
  if (error) {
    return notification.error({
      message: message,
    });
  }
};

export const checkingForWarnNotification = (error, message) => {
  if (error) {
    return notification.error({
      message: message,
    });
  } else {
    notification.warn({
      message: message,
    });
  }
};

export const normalizedData = (data, skuMaster, childToBase) => {
  let new_data = [];
  let prdMap = {};
  let basePrdQuantityMap = {};

  data.map((item) => {
    prdMap[item.product_id] = item;
  });
  data.map((item) => {
    let prdId = item.product_id;
    let sku = skuMaster[prdId];
    let skuId = sku.sku_id;

    let baseSku = childToBase[skuId];
    if (baseSku) {
      let basePrdId = baseSku.id;
      let baseskuMultiplier = sku.meta_data.base.multiplier;
      let baseQuantity =
        prdMap[prdId].quantity_in_metric_ton * baseskuMultiplier;

      basePrdQuantityMap[basePrdId] =
        (basePrdQuantityMap[basePrdId] || 0) + baseQuantity;
    } else {
      let baseQuantity = prdMap[prdId].quantity_in_metric_ton;
      basePrdQuantityMap[prdId] =
        (basePrdQuantityMap[prdId] || 0) + baseQuantity;
    }
  });

  new_data = Object.keys(basePrdQuantityMap).map((prdId) => {
    if (!Object.keys(prdMap).includes(prdId)) {
      prdMap[prdId] = {
        company_id: skuMaster[prdId].company_id,
        product_id: prdId,
        product_multiplier: 1000,
        product_name: skuMaster[prdId].name,
        quantity: basePrdQuantityMap[prdId] * 1000,
        quantity_in_bags: basePrdQuantityMap[prdId] * 1000,
        quantity_in_metric_ton: basePrdQuantityMap[prdId],
        units: 'unit',
      };
    } else {
      prdMap[prdId].quantity_in_metric_ton = basePrdQuantityMap[prdId];
    }
    return prdMap[prdId];
  });
  return new_data;
};


export const divmod = (x, y) => [Math.floor(x / y), x % y];

export const getFormattedStock = (quantity, productId,skuMaster) => {
  const quantities = divmod(
    quantity,
    Number(skuMaster[productId]?.meta_data?.multiplier)
  );
  return `${quantities[0]} ${skuMaster[productId]?.meta_data?.unit} ${quantities[1]} ${skuMaster[productId]?.meta_data?.base_unit}`;
};